export default __webpack_public_path__ + "static/media/4x4_vieux_montreal.431e416d.jpg";